import React, { PureComponent, Fragment } from 'react'
import {
    Typography,
    Switch,
} from '@material-ui/core'
import { CustomTooltip } from 'shared/mui-styles';
import { Help } from '@material-ui/icons';

// import { Button, ButtonGroup } from '@material-ui/core'

const classes = {
    h7: {
        fontSize: '1.10rem',
        fontWeight: '400',
    },
}

class SwitchInFilter extends PureComponent {
    render() {
        const { 
            data, 
            handleFilterChangePipeline
         } = this.props;

        // console.log(data)

        const switches = data.map((obj, i) => (
            <div key={i} >
                <div className="row">
                <div className="col">
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontWeight:'400'}}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <Typography variant="h6" style={classes.h7}>{obj.label}</Typography>
                            {obj.tooltip === 'TBD'?(null)
                            :(<CustomTooltip
                                title={obj.tooltip}
                                placement="right"
                            >
                                <Help fontSize="small" style={{ marginLeft: 7,color: 'rgb(115, 173, 150)' }}  />
                            </CustomTooltip>)
                            }
                        </div>
                       
                        <Switch
                            checked={obj.stateVariable}
                            onChange={handleFilterChangePipeline}
                            value={obj.value}
                        
                            style={{ color: 'rgb(115, 173, 150)' }}
                        />
                    
                      
                    </div>
                </div>
                </div>
            </div>
           
        ))

        return (
            <Fragment>

               {switches}
               
            </Fragment>
        )
    }
}

export default SwitchInFilter;